import { useQuery } from '@tanstack/react-query';

import { pipelineEngineConfig } from '~/api/runtimeService';

type UsePipelineEngineConfigParams = {
  realm: string;
  environment: string;
};

export const usePipelineEngineConfig = ({
  realm,
  environment
}: UsePipelineEngineConfigParams) =>
  useQuery({
    queryKey: ['run', 'pipelineEngineConfig', realm, environment],
    queryFn: () => pipelineEngineConfig({ realm, environment })
  });
